import { AfterViewInit, Component, ElementRef, Input, Renderer2 , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { faInfoCircle, faCheck } from '@fortawesome/pro-regular-svg-icons';
import { ModalController, NavParams, PopoverController } from '@ionic/angular';
import { PopoverComponent } from '../popover/popover.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-program-selection',
    templateUrl: './program-selection.component.html',
    styleUrls: ['./program-selection.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, FontAwesomeModule, PopoverComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ProgramSelectionComponent implements AfterViewInit {
    parentData: any[];
    parentRowData: any[];
    parentRowDatainside: string;
    focus: boolean = false;

    programType: string;
    programTypeElement: ElementRef<HTMLInputElement>;
    faInfoCircle = faInfoCircle;
    faCheck = faCheck;

    @Input() userEmail: string;
    @Input() fieldOfStudy: string;

    constructor(
        private modalController: ModalController,
        private navParams: NavParams,
        public popoverController: PopoverController,
        private renderer: Renderer2
    ) {
        this.parentData = navParams.get('data');
        this.parentRowData = navParams.get('rowData');

        if (this.parentData && this.parentData.length === 1) {
            this.setValue(this.parentData[0], 'PType');
        }
    }

    ngAfterViewInit() {
        if (this.programType) {
            let elem: Element = document.getElementById(this.programType);
            setTimeout(() => {
                this.renderer.setAttribute(elem, 'class', 'focus-selection');
            }, 0);
        }
    }

    async presentPopover(ev: any) {
        const popover = await this.popoverController.create({
            component: PopoverComponent,
            cssClass: 'custom-popover',
            event: ev,
            translucent: true,
            showBackdrop: false,
            mode: 'ios',
            componentProps: { userEmail: this.userEmail },
        });
        await popover.present();

        const { role } = await popover.onDidDismiss();
    }

    ctaClick() {
        this.modalController.dismiss({
            programType: this.programType,
            parentRowData: this.parentRowDatainside,
        });
    }

    dismiss() {
        this.modalController.dismiss();
    }

    setValue(dataType, val) {
        if (val == 'PType') {
            this.programType = dataType;
        } else if (val == 'PTime') {
            this.parentRowDatainside = dataType;
        }
    }
}
